export const sortLocale = 'en';
export const sortOptions: Intl.CollatorOptions = { sensitivity: 'base' };
